const trailsConcluded = (companyTrails) => {
  const isTrailsConcluded = companyTrails?.filter((companyTrail) => {
    return companyTrail.completed === false
  })

  return isTrailsConcluded?.length === 0
}

export default trailsConcluded
